import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-ORG3 — MÉDUSE. Le professeur du déplacement SOUTENU.
 *
 *  Le Harceleur lâche deux missiles rapides à virage serré : la parade est une
 *  esquive TARDIVE — un seul écart, cassé au bon instant. La Méduse fait
 *  l'inverse : elle relâche une grappe de trois dards LENTS à virage MOU. Aucun
 *  ne se déjoue d'un écart unique — trop patients, ils re-suivent l'écart et
 *  reviennent. La seule réponse est de ne jamais s'arrêter, pour que la grappe
 *  entière TRAÎNE derrière soi, dard après dard, sans jamais recoller.
 *
 *  ── Ce qu'elle enseigne ──
 *  Que certaines menaces guidées ne se déjouent pas d'un geste mais d'un ÉTAT :
 *  le mouvement continu. Là où le Harceleur récompense le sang-froid d'attendre,
 *  la Méduse punit l'immobilité — se poser une demi-seconde suffit à laisser la
 *  grappe recoller. C'est le premier pas vers l'esquive soutenue des rideaux de
 *  boss, appris sur une poignée de traqueurs plutôt que sur un mur.
 *
 *  ── Pourquoi trois, lents, et à virage mou ──
 *  Le virage est volontairement sous celui du Harceleur et la vitesse basse : un
 *  joueur qui glisse en continu distance chaque dard, son rayon de courbure étant
 *  trop large pour recoller sur une cible qui file — c'est ce qui garde l'esquive
 *  vivante. Trois seulement, ouverts à l'émission, pour que la grappe se lise
 *  comme une grappe et non comme un mur ; au-delà, la densité ne laisserait plus
 *  de couloir de fuite et la leçon « bouge » deviendrait « meurs ». */
export default defineEnemy({
  id: 'meduse',
  rank: Rank.Standard,
  hp: 180,
  visualRadius: 30,
  score: 260,
  telegraph: 1.1,
  drops: 2,
  // Postée à mi-hauteur, elle oscille juste assez pour rester vivante à l'œil
  // sans devenir un voltigeur : c'est un lâcher de dards, pas un chasseur.
  motion: { kind: Motion.Hover, speed: 240, amplitude: 60, frequency: 0.6, holdY: 320 },
  emitter: {
    pattern: Pattern.Homing,
    every: 2.6,
    count: 3,
    spreadDeg: 40,
    // 360 u/s, franchement lent (plafond 1 500) : la conduite conserve la norme,
    // aucun dard ne s'emballe — et cette lenteur est ce qui rend la traîne
    // possible pour un joueur qui garde de la vitesse.
    speed: 360,
    // 55 °/s : nettement sous les 120 °/s du Harceleur. Assez pour re-suivre un
    // joueur immobile, trop peu pour recoller sur un joueur qui glisse.
    turnDeg: 55,
    firstDelay: 1.6,
    family: Fam.EnemyPink,
  },
});
